import {view, Link} from '@sail/ui';
import {useAnalytics} from '@stripe-internal/inline-data';
import {
  dotComColors,
  dotComTransitions,
  useTheme,
} from '@stripe-internal/conversations-ui';
import {LiveAnswersSource} from '../UniversalHelpLiveAnswersResponse';
import {sourcesLinkClickedActionEvent} from '../analytics';

export const DotComSourcesLink = ({source}: {source: LiveAnswersSource}) => {
  const analytics = useAnalytics();
  const theme = useTheme();

  return (
    <Link
      href={source.url}
      target={source.url}
      onPress={() => {
        analytics.action(sourcesLinkClickedActionEvent, {
          live_answers_source_url: source.url,
          live_answers_source_title: source.title,
          live_answers_source_collection: source.collection,
          live_answers_source_score: source.score,
        });
      }}
      css={{
        maxWidth: '100%',
        stack: 'x',
        alignY: 'center',
        alignX: 'start',
        gap: 'small',
        fontFamily: 'label.medium',
        fontWeight: '600',
        fontSize: '12px',
        color: theme.linkColor,
        transition: dotComTransitions.buttonTransition,
        ':hover': {
          color: dotComColors.brand500,
        },
      }}
    >
      <view.svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <view.path
          d="M4.72725 8.52275C4.53525 8.52275 4.34325 8.44925 4.197 8.303C2.73225 6.8375 2.73225 4.454 4.197 2.98925L5.58525 1.60025C6.29475 0.89075 7.239 0.5 8.2425 0.5C9.246 0.5 10.1895 0.89075 10.899 1.60025C11.6085 2.30975 12 3.254 12 4.2575C12 5.261 11.6092 6.2045 10.899 6.914C10.6057 7.20725 10.1318 7.20725 9.8385 6.914C9.54525 6.62075 9.54525 6.146 9.8385 5.8535C10.2645 5.42675 10.5 4.85975 10.5 4.2575C10.5 3.6545 10.2653 3.0875 9.8385 2.66075C8.98575 1.808 7.4985 1.808 6.64575 2.66075L5.2575 4.049C4.37775 4.9295 4.37775 6.36125 5.2575 7.24175C5.55075 7.535 5.55075 8.009 5.2575 8.30225C5.11125 8.44925 4.91925 8.52275 4.72725 8.52275ZM3.7575 12.4993C2.754 12.4993 1.8105 12.1085 1.101 11.3983C0.3915 10.6895 0 9.74525 0 8.74175C0 7.73825 0.39075 6.79475 1.10025 6.08525C1.3935 5.792 1.8675 5.792 2.16075 6.08525C2.454 6.3785 2.454 6.8525 2.16075 7.14575C1.734 7.57175 1.49925 8.1395 1.49925 8.7425C1.49925 9.3455 1.734 9.9125 2.16075 10.3385C3.01425 11.1912 4.5 11.1912 5.3535 10.3385L6.62775 9.06425C7.05375 8.63825 7.28925 8.07125 7.28925 7.46825C7.28925 6.86525 7.0545 6.29825 6.62775 5.8715C6.3345 5.579 6.3345 5.10425 6.62775 4.811C6.921 4.51775 7.395 4.51775 7.68825 4.811C8.39775 5.5205 8.78925 6.464 8.78925 7.46825C8.78925 8.47175 8.3985 9.416 7.68825 10.1248L6.414 11.399C5.7045 12.1085 4.761 12.4993 3.7575 12.4993Z"
          fill="currentColor"
        />
      </view.svg>

      <view.span
        css={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {source.title}
      </view.span>
    </Link>
  );
};
